import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { LoginModel, RecoverLoginModel } from '../../models/login.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private baseUrl = environment.baseUrl
  private resource = 'Auth'

  constructor(private httpClient: HttpClient) {}

  public loginSystem(model: LoginModel): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/login`,
      // `${this.baseUrl}${this.resource}/login/motorista`,
      model,
    )

    // const body = new URLSearchParams()
    // body.set('email', model.email ?? '')
    // body.set('senha', model.senha ?? '')
    // return this.httpClient.post<ResponseRequestModel>(
    //   `${this.baseUrl}auth/administrativo`,
    //   body,
    //   { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
    // )
  }

  public recoverPassword(
    model: RecoverLoginModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/recuperar-senha`,
      model,
    )
  }
}
